import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import type { ActiveKeyItem } from './types'

interface ActiveKeysState {
  initialActiveKey: ActiveKeyItem | Record<string, never>
  initialActiveKeys: ActiveKeyItem[]
  activeKeys: ActiveKeyItem[]
  setActiveKeys: (keys: ActiveKeyItem[]) => void
}

export const useActiveKeysStore = create<ActiveKeysState>()(
  immer((set) => ({
    initialActiveKey: {},
    initialActiveKeys: [],
    activeKeys: [],
    setActiveKeys: (keys) =>
      set((state) => {
        state.activeKeys = keys
      }),
  })),
)
